export type VariableEditorScope = "Project" | "Unscoped";
export const isProjectScoped = (scope: VariableEditorScope) => {
    if (scope === "Unscoped") {
        return false;
    }
    return true;
};
